module.exports = __webpack_public_path__ + "static/img/6.7df2f5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/6.png
// module id = 49F0
// module chunks = 0